import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class ScoreBox extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this.scoreBg = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_items_score_bg_0, this);

        this.scoreTxt = ABCyaPhaser.Text.addText(-50, 0, 36, 0x9B5940, FontKeys._odin_roundedregular, "0", this, true).setOrigin(0.5);
        this.roundText = ABCyaPhaser.Text.addText(73, 0, 36, 0x9B5940, FontKeys._odin_roundedregular, "1", this, true).setOrigin(0.5);
        this.slash = ABCyaPhaser.Text.addText(101, 0, 36, 0x9B5940, FontKeys._odin_roundedregular, "/", this, true).setOrigin(0.5).setAlpha(0.5);
        this.fourText = ABCyaPhaser.Text.addText(128, 0, 36, 0x9B5940, FontKeys._odin_roundedregular, "4", this, true).setOrigin(0.5).setAlpha(0.5);

        ABCyaPhaser.Text.setFontStyle(this.scoreTxt, true);
        ABCyaPhaser.Text.setFontStyle(this.roundText, true);
        ABCyaPhaser.Text.setFontStyle(this.slash, true);
        ABCyaPhaser.Text.setFontStyle(this.fourText, true);
    }

    updateScore(score)
    {
        this.scoreNum = score;
        this.scoreTxt.text = score;
    }

    updateRound(roundNum)
    {
        this.roundText.text = roundNum;
    }
}